module.exports = __webpack_public_path__ + "img/service-points-scharff.51d6b104.svg";